import {HeatCycleArrayIndex, NvmIndex} from './types';

export const TEMP_HEAT_CYCLE_ARRAY_INDEX = -1;
export const HEAT_CYCLE_ARRAY_INDICES: HeatCycleArrayIndex[] = [0, 1, 2, 3];
export const NVM_INDICES: NvmIndex[] = [0, 1, 2, 3, 4, 5, 6, 7];
